import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/company/findPlatformPage', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/company/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/company/updateById', data)
}
// 修改
export function update (data) {
  return request.post('/company/update', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/company/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/company/delete/batch', {
    params: {
      ids
    }
  })
}
